import type { NormalizedIssue } from "@common/types/issue";

import type { BulkAppliedRule } from "../../context/BulkApplyRunContext";

export function selectBulkApplyRules(candidates: NormalizedIssue[]): BulkAppliedRule[] {
  return candidates.flatMap((candidate) =>
    candidate.ruleUuid && candidate.match
      ? [{ ruleId: candidate.ruleUuid, ruleName: candidate.name }]
      : [],
  );
}
